import StorageService from "../session/storage.service";
import StorageType from "../session/storage.enum";
import AppSetting from "../../common/constants/appsetting.constant";
import axios from "axios";
import moment from "moment";
import Utilities from "../commonservice/utilities";

const ChartNotesService = {
  loggedInUserData: {},
  findAppointmentData: {},
  isFromAddAppointment: false,

  getLoggedInData() {
    return JSON.parse(StorageService.get('session', "userDetails")
    );
  },


  getChartNotes(reqObj){
    // Make sure all details are returned including those with isDeleted = true

    let url = AppSetting.chartNotes.findChartNotes
    .replace('{providerId}', this.getLoggedInData()['parentId']) + this.buildQuery(reqObj);

    return axios.get(url)
      .then(res => {
        res.data?.data?.forEach((element) => {
          element.appointmentDate = Utilities.convertDBSchedulingDateToUIFormat(element.appointmentDate)
        });
        return res.data 
      })
      .catch(err =>{
        return err
      });

  },



  updateChartNotes(reqObj){

    let providerId = this.getLoggedInData()['parentId'];

    reqObj?.forEach((chartNote, i) => {
      chartNote.providerId = providerId;
    });    

    let url = AppSetting.chartNotes.addAll
    .replace('{providerId}', providerId);

    return axios.post(url, reqObj)
      .then(res => { 
        return res 
      })
      .catch(err =>{
        return err
      });

  },




  getTreatmentPlans(reqObj){
    let url = AppSetting.chartNotes.findTreatmentPlans
    .replace('{providerId}', this.getLoggedInData()['parentId']) + this.buildQuery(reqObj);

    return axios.get(url)
      .then(res => { 
        return res.data 
      })
      .catch(err =>{
        return err
      });


  },
  getChartNotesMissingInInvoice(reqObj){
    let url = AppSetting.chartNotes.getChartNotesMissingInInvoice
    .replace('{providerId}', this.getLoggedInData()['parentId']) + this.buildQuery(reqObj);
    return axios.get(url)
      .then(res => { 
        return res.data 
      })
      .catch(err =>{
        return err
      });

  },


  buildQuery(data) {
    let queryData = "";
    for (const prop in data) {
      if (
        data[prop] !== "" &&
        data[prop] !== "undefined" &&
        data[prop] !== null
      ) {
        if (queryData === "") {
          queryData = "?" + prop + "=" + data[prop];
        } else {
          queryData += "&" + prop + "=" + data[prop];
        }
      }
    }
    return queryData;
  }
}

export default ChartNotesService